import React, { useContext } from 'react';
import styled from 'styled-components';
import { BuyerAgreementContext } from 'contexts';
import { featureEnabled } from 'utils';
import Checkbox from '../Checkbox';
import Divider from '../Divider';
import { Text } from '../Typography';

const BuyerAgreementCheckbox: React.FC<{ isTour?: boolean }> = ({ isTour }) => {
  const { hasBuyerAgreed, setHasBuyerAgreed } = useContext(
    BuyerAgreementContext,
  );

  if (!featureEnabled('narBuyerSettlementFeature')) return null;

  return (
    <>
      {!isTour && <Divider />}
      <StyledCheckbox
        // Checkbox doesn't seem to be inserting style through styled-components
        style={{ display: 'flex' }}
        checked={hasBuyerAgreed}
        onChange={e => setHasBuyerAgreed?.(e.target.checked)}
        $isTour={isTour}
      >
        <StyledText>
          I understand that a participant working with a buyer must enter into a
          written agreement with the buyer prior to the buyer touring any home.
        </StyledText>
      </StyledCheckbox>
    </>
  );
};

const StyledCheckbox = styled(Checkbox)<{ $isTour?: boolean }>`
  padding: ${({ $isTour }) => ($isTour ? '0 0 16px' : '0 16px 16px 16px')};
`;

const StyledText = styled(Text)`
  font-weight: 400;
`;

export default BuyerAgreementCheckbox;
